export default "__VITE_ASSET__62d731fe__"